import './nuevoStroLight.css';
import { useCookies } from 'react-cookie';
import SlideEstadosReclamoLight from './SlideEstadosReclamoLight';
import PlanillaReclamosNuevaLight from './PlanillaReclamosNuevaLight';
import { useActualizarSiniestro } from '../../../context/ActualizarSiniestro';
export default function ReclamoSeleccionado({ reclamo, stro }) {
  const [cookies] = useCookies(['user'], ['asignado']);
  const { actualizarReclamo, reclamosEditados } = useActualizarSiniestro();
  const reclamoActualizado = reclamosEditados?.find(r => r.id === reclamo.id);
  //
  const optionsCarga = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'StellaM', label: 'StellaM', key: 3 },
    { value: 'DanielaM', label: 'DanielaM', key: 4 },
    { value: 'rosario', label: 'rosario', key: 5 },
  ];
  const optionsChoque = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'DanielaM', label: 'DanielaM', key: 3 },
    { value: 'DiegoD', label: 'DiegoD', key: 4 },
    { value: 'DiegoS', label: 'DiegoS', key: 5 },
    { value: 'OrelyC', label: 'OrelyC', key: 6 },
    { value: 'StellaM', label: 'StellaM', key: 7 },
    { value: 'LucianaF', label: 'LucianaF', key: 8 },
    { value: 'CandelaS', label: 'CandelaS', key: 9 },
    { value: 'MagaliG', label: 'MagaliG', key: 10 },
    { value: 'PilarS', label: 'PilarS', key: 11 },
    { value: 'Maurom', label: 'Maurom', key: 12 },
    { value: 'ClaudiaF', label: 'ClaudiaF', key: 13 },
    { value: 'Gian', label: 'Gian', key: 14 },
    { value: 'rosario', label: 'rosario', key: 15 },
  ];
  const optionsContractuales = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'DanielaM', label: 'DanielaM', key: 3 },
    { value: 'DiegoD', label: 'DiegoD', key: 4 },
    { value: 'DiegoS', label: 'DiegoS', key: 5 },
    { value: 'OrelyC', label: 'OrelyC', key: 6 },
    { value: 'StellaM', label: 'StellaM', key: 7 },
    { value: 'LucianaF', label: 'LucianaF', key: 8 },
    { value: 'CandelaS', label: 'CandelaS', key: 9 },
    { value: 'MagaliG', label: 'MagaliG', key: 10 },
    { value: 'PilarS', label: 'PilarS', key: 11 },
    { value: 'Augusto', label: 'Augusto', key: 12 },
    { value: 'PaulaC', label: 'PaulaC', key: 13 },
    { value: 'MariaE', label: 'MariaE', key: 14 },
    { value: 'rosario', label: 'rosario', key: 15 },
  ];
  // catStro
  const responsabilidad = reclamoActualizado?.catStro;
  const handleResponsabilidadChange = e => {
    actualizarReclamo(reclamo.id, 'catStro', e.target.value);
  };
  // Asignado
  const selectedOption = reclamoActualizado?.asignado;
  const handleAsignadoChange = e => {
    actualizarReclamo(reclamo.id, 'asignado', e.target.value);
  };
  // estado
  const estado = reclamoActualizado?.estado;
  const handleEstadoChange = e => {
    actualizarReclamo(reclamo.id, 'estado', e.target.value);
  };
  // monto
  const monto = reclamoActualizado?.monto;
  const handleMontoChange = e => {
    actualizarReclamo(reclamo.id, 'monto', e.target.value);
  };
  // comercial
  const comercial = reclamoActualizado?.comercial;
  const handleComercialChange = e => {
    actualizarReclamo(reclamo.id, 'comercial', e.target.value);
  };
  // porcentaje
  const porcentaje = reclamoActualizado?.porcentaje;
  const handlePorcentajeChange = e => {
    actualizarReclamo(reclamo.id, 'porcentaje', e.target.value);
  };
  // aceptacion
  const aceptacion = reclamoActualizado?.aceptacion;
  const handleAceptacionChange = e => {
    actualizarReclamo(reclamo.id, 'aceptacion', e.target.value);
  };
  // f15
  const f15 = reclamoActualizado?.f15 ?? false;
  const handleF15Change = e => {
    const nuevoValor = e.target.checked;
    actualizarReclamo(reclamo.id, 'f15', nuevoValor);
  };
  // orden pago
  const ordenPago = reclamoActualizado?.ordenDePago;
  const handleOrdenPagoChange = e => {
    actualizarReclamo(reclamo.id, 'ordenDePago', e.target.value);
  };
  // aceptacion
  const fRecRecibido = reclamoActualizado?.fRecRecibido;
  const handleRecRecibidoChange = e => {
    actualizarReclamo(reclamo.id, 'fRecRecibido', e.target.value);
  };
  // obs
  const obs = reclamoActualizado?.obs;
  const handleObsChange = e => {
    actualizarReclamo(reclamo.id, 'obs', e.target.value);
  };
  const valoresEstado = reclamoActualizado?.valores?.[Number(estado)] || {};
  const primerValor = valoresEstado[Object.keys(valoresEstado)[0]];
  return (
    <section className='reclamoNuevoContainer'>
      <div className='d-flex gap-4' style={{ alignItems: 'end' }}>
        <div className='w-50'>
          <span className='reclamoSpan'>Código</span>
          <input
            className='burbujaReclamoNuevo'
            type='number'
            value={responsabilidad ?? ''}
            disabled={cookies?.user?.titulo === 'lector'}
            onChange={handleResponsabilidadChange}
            style={{
              border: responsabilidad === null || responsabilidad === '' ? '1px solid red' : null,
            }}
          />
        </div>
        <div className={!selectedOption ? 'selectReclamoSinAsignar w-75' : 'selectReclamoAsignar w-100'}>
          <select
            value={selectedOption}
            key={reclamoActualizado?.id}
            onChange={handleAsignadoChange}
            className='select'
            disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision'}>
            <option value=''>Asignado</option>
            {cookies.user.depto === 'cargas'
              ? optionsCarga.map(option => (
                  <option key={option.key} value={option.value}>
                    {option.label}
                  </option>
                ))
              : cookies.user.depto === 'choques'
                ? optionsChoque.map(option => (
                    <option key={option.key} value={option.value}>
                      {option.label}
                    </option>
                  ))
                : cookies.user.depto === 'contractuales'
                  ? optionsContractuales.map(option => (
                      <option key={option.key} value={option.value}>
                        {option.label}
                      </option>
                    ))
                  : null}
          </select>
        </div>
        <div className='selectReclamoAsignar w-100' style={{ backgroundColor: reclamo?.estado === 204 ? 'black' : (reclamo?.estados?.find(e => e.id === Number(estado))?.hexa ?? '#D8D8D8') }}>
          {cookies.user.id === 107 ? (
            <select value={estado} onChange={handleEstadoChange} className='select' disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : false}>
              <option value='302'>ENVIADO A COTIZAR</option>
              <option value='311'>COTIZADO</option>
            </select>
          ) : (
            <select value={estado} onChange={handleEstadoChange} className='select' disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : false}>
              <option value='' disabled>
                Estado
              </option>
              {reclamo?.estados?.map(option => (
                <option key={option.id} value={option.id}>
                  {option.nombre}
                </option>
              ))}
              {reclamo?.estado === 204 ? <option value='204'>POSIBLE DUPLICADO</option> : null}
            </select>
          )}
        </div>
        <div className='w-100'>
          <span className='reclamoSpan'>F.Rec Recibido</span>
          <input className='burbujaReclamoNuevo' type='date' key={reclamoActualizado?.id} value={fRecRecibido} onChange={handleRecRecibidoChange} disabled={cookies?.user?.titulo === 'lector'} />
        </div>
      </div>
      <div style={{ marginTop: '20px' }} className='d-flex gap-4'>
        <div className='w-100'>
          <span className='reclamoSpan'>Monto</span>
          <input className='burbujaReclamoNuevo' type='number' value={monto} key={reclamoActualizado?.id} onChange={handleMontoChange} disabled={cookies?.user?.titulo === 'lector'} />
        </div>
        <div className='w-100'>
          <span className='reclamoSpan'>Comercial</span>
          <input className='burbujaReclamoNuevo' type='number' value={comercial} onChange={handleComercialChange} key={reclamoActualizado?.id} disabled={cookies?.user?.titulo === 'lector'} />
        </div>
        <div className='w-100'>
          <span className='reclamoSpan'>Porcentaje</span>
          <input className='burbujaReclamoNuevo' type='number' value={porcentaje} onChange={handlePorcentajeChange} key={reclamoActualizado?.id} disabled={cookies?.user?.titulo === 'lector'} />
        </div>
        <div className='w-100'>
          <span className='reclamoSpan'>Aceptación</span>
          <input className='burbujaReclamoNuevo' type='date' key={reclamoActualizado?.id} value={aceptacion} onChange={handleAceptacionChange} disabled={cookies?.user?.titulo === 'lector'} />
        </div>
        {[400, 401, 402, 403, 404, 405, 500, 550, 590, 600, 700, 800, 820, 900, 999].includes(Number(reclamoActualizado?.catStro)) && (
          <div className='w-25'>
            <span className='reclamoSpan'>F15</span>
            <input
              className='form-check-input'
              type='checkbox'
              key={reclamoActualizado?.id}
              id={`f15-${reclamoActualizado?.id}`}
              checked={!!f15}
              onChange={handleF15Change}
              disabled={cookies?.user?.titulo === 'lector'}
            />
          </div>
        )}
        <div className='w-100'>
          <span className='reclamoSpan'>Orden de Pago</span>
          <input className='burbujaReclamoNuevo' type='number' key={reclamoActualizado?.id} value={ordenPago} onChange={handleOrdenPagoChange} disabled={cookies?.user?.titulo === 'lector'} />
        </div>
      </div>
      <div style={{ marginTop: '20px' }} className='w-100'>
        <span className='reclamoSpan'>Obs</span>
        <textarea className='textareaReclamoNuevo' value={obs} key={reclamoActualizado?.id} onChange={handleObsChange} disabled={cookies?.user?.titulo === 'lector'} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '30px' }} className='gap-4'>
        {reclamo?.reclamo3ro?.linkSharepoint ? (
          <div>
            <a href={reclamo?.reclamo3ro?.linkSharepoint} target='_blank' rel='noopener noreferrer'>
              Documentación
            </a>
          </div>
        ) : null}
        <button className='btnVerEstadosReclamo' type='button' data-bs-toggle='offcanvas' data-bs-target='#offcanvasRight20' aria-controls='offcanvasRight20'>
          VER PLANILLA RECLAMO
        </button>
        <button className='btnVerEstadosReclamo' type='button' data-bs-toggle='offcanvas' data-bs-target='#offcanvasRight10' aria-controls='offcanvasRight10'>
          VER TODOS LOS ESTADOS
        </button>
        <button className='btnActualizarReclamo' disabled /*onClick={(e) => actualizarValores(e, estado1, reclamo?.camposEstado[0]?.nombre)}*/>
          ACTUALIZAR RECLAMO
        </button>
      </div>
      {/** Estados */}
      <div class='offcanvas offcanvas-end w-75' tabindex='-1' id='offcanvasRight10' aria-labelledby='offcanvasRightLabel10'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>
          <SlideEstadosReclamoLight reclamo={reclamo} />
        </div>
      </div>
      {/** Planilla Reclamos */}
      <div class='offcanvas offcanvas-end w-75' tabindex='-1' id='offcanvasRight20' aria-labelledby='offcanvasRightLabel20'>
        <div class='offcanvas-header'>
          <button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'></button>
        </div>
        <div class='offcanvas-body pe-5 ps-5'>
          <PlanillaReclamosNuevaLight r={reclamo?.idPlanillaReclamo} stro={stro} />
        </div>
      </div>
    </section>
  );
}
